import { SupabaseConnectionPool, getPoolConfig } from '../utils/connectionPool';
import { supabase, isProd } from './client';

let supabasePool: SupabaseConnectionPool | null = null;

export const getSupabasePool = (): SupabaseConnectionPool | null => {
  if (!supabase || !supabase.from) return null;

  if (!supabasePool) {
    supabasePool = new SupabaseConnectionPool(supabase, getPoolConfig());
    console.log('🔄 Connection pool initialized');
  }

  return supabasePool;
};

export const closeSupabasePool = (): void => {
  if (supabasePool) {
    supabasePool.close();
    supabasePool = null;
    console.log('🔄 Connection pool closed');
  }
};

if (isProd && typeof window !== 'undefined') {
  const poolStatusInterval = setInterval(() => {
    const pool = getSupabasePool();
    if (pool) {
      console.log(pool.getPoolStatus());
    }
  }, 5 * 60 * 1000);

  window.addEventListener('beforeunload', () => {
    clearInterval(poolStatusInterval);
  });
}
